import React from "react";

export function GlowOrb({ className = "", color = "flame", size = 400 }) {
  const bg = color === "mint" ? "rgba(0,229,153,0.12)" : "rgba(255,69,0,0.16)";
  return (
    <div aria-hidden className={`pointer-events-none absolute rounded-full blur-[120px] ${className}`} style={{ width: size, height: size, background: bg }} />
  );
}

export function SectionLabel({ icon: Icon, children }) {
  return (
    <span className="inline-flex items-center gap-2 rounded-full border border-[#FF4500]/30 bg-[#FF4500]/5 px-4 py-1.5 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-[#FF4500]">
      {Icon && <Icon className="h-3.5 w-3.5" />}
      {children}
    </span>
  );
}
